import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ResultCard from "@/components/ResultCard";
import ResultCardSkeleton from "@/components/ResultCardSkeleton";
import StructuredData from "@/components/StructuredData";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { useLotteryResults } from "@/hooks/useLotteryResults";

const TicaAntier = () => {
  const { data: results, isLoading } = useLotteryResults(2);
  const costaRicaResults = results?.costaRicaResults || [];

  const dayBeforeYesterday = new Date();
  dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2);
  const dateStr = dayBeforeYesterday.toLocaleDateString('es-ES', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <>
      <StructuredData
        title="Resultados de Antier - Tiempos JPS Costa Rica"
        description="Resultados de antier de los Tiempos JPS de Costa Rica"
        results={costaRicaResults}
        country="costa-rica"
      />
      
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1 container mx-auto px-4 py-8">
          <header className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-costa-rica">
              🇨🇷 Resultados de Nuevos Tiempos de Costa Rica de antier
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-2">
              Resultados de los Tiempos JPS
            </p>
            <p className="text-sm text-muted-foreground capitalize">{dateStr}</p>
          </header>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <Button asChild variant="outline">
              <Link to="/tiempos-tica-hoy">Hoy</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/que-salio-ayer-en-tiempos-jps">Ayer</Link>
            </Button>
            <Button asChild variant="default">
              <Link to="/tica-antier">Antier</Link>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {isLoading ? (
              <>
                <ResultCardSkeleton country="costa-rica" />
                <ResultCardSkeleton country="costa-rica" />
                <ResultCardSkeleton country="costa-rica" />
              </>
            ) : costaRicaResults.length > 0 ? (
              costaRicaResults.map((result, index) => (
                <ResultCard
                  key={index}
                  country="costa-rica"
                  {...result}
                  isPlayed={true}
                />
              ))
            ) : (
              <p className="text-center text-muted-foreground col-span-full">No hay resultados disponibles para antier.</p>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default TicaAntier;
